import { isAppleDevice } from 'helpers/utils';

import { addLogsToSentry } from '../helpers/sentry';

// ? ongoing issue with iOS and Mac. ref - https://bugs.webkit.org/show_bug.cgi?id=277615
const iosMacConnectionLostErrorMsg =
  'Connection to Indexed Database server lost. Refresh the page to try again';

const isIosMacConnectionLostError = (error: Error): boolean => {
  const isConnectionLost =
    error.name === 'UnknownError' &&
    error.message === iosMacConnectionLostErrorMsg &&
    isAppleDevice();

  if (isConnectionLost) console.warn('idb connection lost');
  return isConnectionLost;
};

const logIDBSentryError = (err: Error, errorName: string): void => {
  if (isIosMacConnectionLostError(err)) return;

  addLogsToSentry(null, err as Error, undefined, {
    errorName,
  });
};

export { logIDBSentryError };
